
      
      var Shopify = Shopify || {};
    // ---------------------------------------------------------------------------
    // Money format handler
    // ---------------------------------------------------------------------------
    Shopify.money_format = "${{amount}}";
    Shopify.formatMoney = function(cents, format) {
    if (typeof cents == 'string') { cents = cents.replace('.',''); }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || this.money_format);
    
    function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
    }
    
    function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');
    
    if (isNaN(number) || number == null) { return 0; }
    
    number = (number/100.0).toFixed(precision);
    
    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';
    
    return dollars + cents;
    }
    
    switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    }

    return formatString.replace(placeholderRegex, value);
    };
    
    var convertCurrencies = function() {
      if (Shopify.currency_settings.shopifyMultiCurrencyIsEnabled == true) {
        // Select event for native multi currency checkout
        document.querySelectorAll('.shopify-currency-form [data-native-currency-converter]').forEach(function(el) {
          el.addEventListener('change', function() {
            this.closest('form').submit();
          });
        });
        applyCurrencyFormatSettings();
      }
      else {
        var shopCurrency = Shopify.currency_settings.shop_currency;
    
        /* Sometimes merchants change their shop currency, let's tell our JavaScript file */
        Currency.money_with_currency_format[shopCurrency] = Shopify.currency_settings.money_with_currency_format;
        Currency.money_format[shopCurrency] = Shopify.currency_settings.money_format;
    
        /* Default currency */
        // if multicurrency is checked, show default currency from settings.. if not use shop currency (comes from backend)
        if (Shopify.theme_settings.show_multiple_currencies == true) {
          var defaultCurrency = Shopify.currency_settings.default_currency;
        } else {
          var defaultCurrency = shopCurrency;
        }
    
        var currencySelector = document.querySelector('#currency_wrapper .currencies');
        /* Cookie currency */
        var cookieCurrency = Currency.cookie.read();
    
        /* Fix for customer account pages */
        document.querySelectorAll('span.money span.money').forEach(function(el) {
          var parent = el.closest('span.money');
          if (parent && parent !== el) {
            parent.classList.remove('money');
          }
        });
    
        /* Saving the current price */
        document.querySelectorAll('span.money').forEach(function(el) {
          el.setAttribute('data-currency-' + Shopify.currency_settings.shop_currency, el.innerHTML);
        });
    
        // If there's no cookie, check if shopCurrency is different from the default currency (set above). If so, convert currencies to the default currency
        if (cookieCurrency == null) {
          if (shopCurrency !== defaultCurrency) {
            Currency.convertAll(shopCurrency, defaultCurrency, 'span.money', Shopify.theme_settings.currency_format);
            document.querySelectorAll('.selected-currency').forEach(function(el) {
              el.textContent = Currency.currentCurrency;
            });
          }
          // If shopCurreny is the same as defaultCurrency, no need to convert anything.. just set the current currency for later
          else {
            Currency.currentCurrency = defaultCurrency;
          }
        }
        // If the cookie value does not correspond to any value in the currency dropdown.
        else if (currencySelector && !currencySelector.querySelector('option[value="' + cookieCurrency + '"]')) {
          Currency.currentCurrency = shopCurrency;
          Currency.cookie.write(shopCurrency);
        }
        // If there is a cookie, and it's the same as our shopCurrency, set the current currency for later
        else if (cookieCurrency === shopCurrency) {
          Currency.currentCurrency = shopCurrency;
        }
        // Then, if we reach the else statement, there is a cookie, but its different from the shopCurrency we have set in our backend, so we convert the currencies to reflect the cookie's currency
        else {
          Currency.convertAll(shopCurrency, cookieCurrency, 'span.money', Shopify.theme_settings.currency_format);
          document.querySelectorAll('.selected-currency').forEach(function(el) {
            el.textContent = Currency.currentCurrency;
          });
        }
        
        // On currency selector dropdown change, we convert currencies to the new currency along with the format we have set
        if (currencySelector) {
          currencySelector.value = Currency.currentCurrency;
          currencySelector.addEventListener('change', function() {
            var newCurrency = this.value;
            
            currencySelector.querySelectorAll('option').forEach(function(opt) {
              opt.removeAttribute('selected');
            });
            var selectedOpt = currencySelector.querySelector('option[value="' + newCurrency + '"]');
            if (selectedOpt) selectedOpt.setAttribute('selected', 'selected');
          
            if (Currency.currentCurrency !== '') {
              Currency.convertAll(Currency.currentCurrency, newCurrency, 'span.money', Shopify.theme_settings.currency_format);
            } else {
              Currency.convertAll(shopCurrency, newCurrency, 'span.money', Shopify.theme_settings.currency_format);
            }
      
            document.querySelectorAll('.selected-currency').forEach(function(el) {
              el.textContent = Currency.currentCurrency;
            });
      
            // check for when newCurrency is the same as shopCurrency. Inside the convertAll function, this would return the function false, and thus the currency format won't be updated. applyCurrencyFormatSettings() won't convert the currency, just format the money.
            if (newCurrency === shopCurrency) {
              applyCurrencyFormatSettings();
            }
          });
      
          var defaultShopCurrency = currencySelector.dataset.defaultShopCurrency;
          if (currencySelector.value && currencySelector.value != defaultShopCurrency) {
            Currency.convertAll(defaultShopCurrency, currencySelector.value, 'span.money', Shopify.theme_settings.currency_format);
            document.querySelectorAll('.selected-currency').forEach(function(el) {
              el.textContent = Currency.currentCurrency;
            });
          } else {
            applyCurrencyFormatSettings();
          }
        }
      }
    }
    
    // when the two arguments into Currency.convertAll are the same, it will return false, thus in order to still change currency format, we run this function. Example: Currency.convertAll('USD', 'USD') .... this will return false
    var applyCurrencyFormatSettings = function() {
      document.querySelectorAll('span.money').forEach(function(el) {
        // get price text
        var money = el.innerHTML;
        // convert it to cents and strip it down
        if (Shopify.currency_settings.money_with_currency_format.includes('amount_with_comma_separator')) {
          money = Number(money.replace(/[^0-9\.]+/g, "").replace(/\.|,/gi, ''));
        } else if (Shopify.currency_settings.money_with_currency_format.includes('amount_no_decimals_with_comma_separator')) {
          money = Number(money.replace(/[^0-9\.]+/g, "").replace(/\.|,/gi, '')) * 100;
        } else {
          money = Number(money.replace(/[^0-9\.]+/g, "")) * 100;
        }
        // output it back using updated money
        var moneyFormat = document.body.dataset.moneyFormat;
        el.textContent = Shopify.formatMoney(money, moneyFormat);
      });
    }
    
    
    